module.exports = __webpack_public_path__ + "static/media/homepage-02.0eda2f50.png";